import styled from "styled-components";

import { colors, radii, shadows } from "shared/ui/tokens";

// Брейкпоинты экрана меню (см. правила раскладки в дизайн-хендоффе):
// ≥1600 — 4 колонки плиток, 1280–1599 — 3, 960–1279 — 2 и узкий сайдбар,
// <960 — сайдбар превращается в кнопку-селектор с нижним листом.
export const WIDE_BREAKPOINT = 1600;
export const DESKTOP_BREAKPOINT = 1280;
export const MOBILE_BREAKPOINT = 960;

// Отдельный порог для содержимого плитки. Сайдбар сворачивается в кнопку-селектор уже
// на 960, но плитка при этом остаётся широкой (~300px в две колонки) — описание в ней
// ещё читается. По-настоящему узкой она становится только на телефоне.
export const COMPACT_TILE_BREAKPOINT = 600;

export const Container = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 24px;
    /* min-width: 0 — иначе сетка плиток распирает колонку контента внутри LayoutWithMenu. */
    min-width: 0;
`;

// Сайдбар — белая карточка на фоне страницы (как в макете), поэтому фон и тень живут
// здесь, а не в CategoryList: тот же список рендерится в нижнем листе на мобильном,
// где карточка поверх карточки выглядела бы лишним слоем.
export const Aside = styled.aside`
    flex: 0 0 280px;
    width: 280px;
    position: sticky;
    top: 16px;
    align-self: flex-start;
    padding: 12px;
    border-radius: ${radii.base};
    background: ${colors.surface};
    box-shadow: ${shadows.panel};

    @media (max-width: ${DESKTOP_BREAKPOINT - 1}px) {
        flex-basis: 240px;
        width: 240px;
    }

    @media (max-width: ${MOBILE_BREAKPOINT - 1}px) {
        display: none;
    }
`;

export const Content = styled.div`
    flex: 1 1 auto;
    min-width: 0;
`;

export const MobileCategoryBar = styled.div`
    display: none;
    margin-bottom: 16px;

    @media (max-width: ${MOBILE_BREAKPOINT - 1}px) {
        display: flex;
        align-items: center;
        gap: 8px;
    }
`;

export const CategorySelectorButton = styled.button`
    flex: 1 1 auto;
    min-width: 0;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    padding: 0 14px;
    border: 1px solid ${colors.fieldBorder};
    border-radius: 8px;
    background: ${colors.surface};
    font-family: inherit;
    font-size: 15px;
    font-weight: 600;
    color: ${colors.textPrimary};
    cursor: pointer;

    svg {
        font-size: 20px;
        color: ${colors.textSecondary};
    }
`;

export const Message = styled.div`
    padding: 24px;
    color: ${colors.textSecondary};
`;
